export var StatusesEnum;

(function (StatusesEnum) {
  StatusesEnum["Active"] = "ACTIVE";
  StatusesEnum["Block"] = "BLOCKED";
  StatusesEnum["New"] = "NEW";
  StatusesEnum["PinLocked"] = "PIN_LOCKED";
})(StatusesEnum || (StatusesEnum = {}));

export var GroupsEnum;

(function (GroupsEnum) {
  GroupsEnum["Admin"] = "Admin";
  GroupsEnum["Registrar"] = "Registrar";
  GroupsEnum["Auditor"] = "Auditor";
})(GroupsEnum || (GroupsEnum = {}));

export var PermissionEnum;

(function (PermissionEnum) {
  PermissionEnum["MANAGE_ADMIN_CONSOLE_USERS"] = "Manage Admin Console Users";
  PermissionEnum["MANAGE_WISPER_USERS"] = "Manage Wisper Users";
  PermissionEnum["MANAGE_ADMIN_CONSOLE_GROUPS"] = "Manage Admin Console Groups";
  PermissionEnum["READ_ONLY"] = "Read-only";
})(PermissionEnum || (PermissionEnum = {}));

export var RoleEnum;

(function (RoleEnum) {
  RoleEnum["MANAGE_ADMIN_CONSOLE_USERS"] = "MANAGE_ADMIN_CONSOLE_USERS";
  RoleEnum["MANAGE_WISPER_USERS"] = "MANAGE_WISPER_USERS";
  RoleEnum["MANAGE_ADMIN_CONSOLE_GROUPS"] = "MANAGE_ADMIN_CONSOLE_GROUPS";
  RoleEnum["READ_ONLY"] = "READ_ONLY";
})(RoleEnum || (RoleEnum = {}));

export var UserTypeEnum;

(function (UserTypeEnum) {
  UserTypeEnum["ADMIN_CONSOLE_USER"] = "ADMIN_CONSOLE_USER";
  UserTypeEnum["REGISTRAR"] = "REGISTRAR";
  UserTypeEnum["WISPER_USER"] = "WISPER_USER";
})(UserTypeEnum || (UserTypeEnum = {}));